import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { style } from './avatar.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


export const avatarSizes = ['small', 'medium', 'large', 'extra-large'] as const
export type avatarSizesType = typeof avatarSizes

@customElement('cse-avatar')
export class CSEAvatar extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String })
  size: avatarSizesType[number] = 'medium'

  override render() {
    return html`
      <div class="${classMap({
        'cse-avatar': true,
        [`size-${this.size}`]: true,
      })}">
        <slot>fallback image</slot>
      </div>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-avatar': CSEAvatar
  }
}
